import { compose, hoistStatics, withState, withHandlers, lifecycle } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import GifPicker from './GifPicker';
import GifsService from '../../../services/gif.service';

const goToPage = props => async (nextPage, val) => {
  const { setCriteria,
    criteria,
    setGifURLs,
    isLoad,
    setIsLoad,
    gifURLs,
    setHasMore } = props;
  if (!isLoad) {
    setIsLoad(true);
    const tag = val || criteria.value;
    const newPos = val && val !== criteria.value ? 0 : criteria.pos;
    const { data } = await GifsService.getData({ limit: criteria.limit, tag, pos: newPos });
    if (data.next === '0')setHasMore(false);
    else setHasMore(true);
    const gifsArr = [];
    data.results.forEach((gifObj) => {
      gifsArr.push(gifObj.media[0].tinygif.url);
    });
    setCriteria({ ...criteria, pos: data.next, value: tag });
    if (val && val !== criteria.value) {
      const gifBox = document.getElementById('gif-box');
      gifBox.scrollTo({ top: 0, behavior: 'smooth' });
      setGifURLs(gifsArr);
    } else {
      setGifURLs([...gifURLs, ...gifsArr]);
    }
    setIsLoad(false);
  }
};

const callbackToSetSearch = props => async (value) => {
  await goToPage(props)(0, value);
};

const defaultCriteria = {
  limit: 20,
  pos: 0,
};

const enhance = compose(
  translate('portal'),
  withState('isSubmitting', 'setIsSubmitting', false),
  withState('gifURLs', 'setGifURLs', []),
  withState('criteria', 'setCriteria', defaultCriteria),
  withState('hasMore', 'setHasMore', true),
  withState('isLoad', 'setIsLoad', false),
  lifecycle({
    async componentDidMount() {
      await callbackToSetSearch(this.props)('');
    },
  }),
  withHandlers({
    goToPage,
    callbackToSetSearch,
  }),
);

export default withRouter(hoistStatics(enhance)(GifPicker));



// WEBPACK FOOTER //
// ./src/components/comments/gifPicker/index.js